import React from 'react'
import ReactDOM from 'react-dom'
import SharedSortableLists from './SharedSortableLists'
import CsrTeamMembersIndex from './CsrTeamMembersIndex'

class CsrSortableTeamMembersList extends SharedSortableLists {
  sortMapping() {
    return {
      deadline: "deadline_day",
      status: "titleized_status",
      rounds: "rounds_of_revisions_raw",
      annotations: "annotations_raw",
      overage_fees: "overage_fees_raw",
      time_in_waiting: "time_in_waiting_raw",
      time_in_revisions: "time_in_revisions_raw",
    };
  }

  defaultSortKey() {
    return "deadline"
  }

  renderList(sorted) {
    ReactDOM.render(<CsrTeamMembersIndex data={sorted} />, $(this._container)[0])
  }

  sortData() {
    let sortAttr = this.sortMapping()[this.sortKey];
    switch (this.sortKey) {
      case "deadline":
        return this.sortBy({attr: sortAttr, reverse: true})
        break;

      case "annotations":
      case "overage_fees":
      case "rounds":
      case "time_in_waiting":
      case "time_in_revisions":
        return this.sortBy({attr: sortAttr})
        break;

      case "status":
        return this.sortBy({attr: sortAttr});
        break;

      default:
        return this.sortBy({attr: 'id'});
    }
  }

  updateData(key, newData) {
    this.data = newData;
    this.render();
  }
}

export default CsrSortableTeamMembersList
